// extracted by mini-css-extract-plugin
module.exports = {"profileImage":"helloWidget-module--profile-image--1eeWj","blurb":"helloWidget-module--blurb--2y6IG","container":"helloWidget-module--container--2G4Y6"};